/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { jsx } from '@atlaskit/css';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

export type DeleteConfirmModalProps = {
	title: string;
	body: string;
	isOpen: boolean;
	isLoading: boolean;
	onClose: () => void;
	onConfirm: () => void;
	testId?: string;
};

export const DeleteConfirmModal = ({
	title,
	body,
	isOpen,
	isLoading,
	onClose,
	onConfirm,
	testId = 'delete-confirm-modal',
}: DeleteConfirmModalProps): JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!isOpen) {
		return null;
	}

	return (
		<Modal
			onClose={onClose}
			width="small"
			shouldCloseOnEscapePress
			shouldCloseOnOverlayClick
			testId={testId}
		>
			<ModalHeader hasCloseButton>
				<ModalTitle>{title}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Text>{body}</Text>
			</ModalBody>
			<ModalFooter>
				<Button appearance="subtle" onClick={onClose}>
					{formatMessage(messages.cancel)}
				</Button>
				<Button appearance="danger" isLoading={isLoading} onClick={onConfirm}>
					{formatMessage(messages.delete)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
